import type { LoaderFunction } from 'react-router-dom';
import { userService } from '@/services/userService.ts';

export const rootRouteLoader: LoaderFunction = async (_args) => {
  const user = await userService.getCurrentUser();

  return user.domain;
};
